import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../Context/AuthContext"
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import MobileMenuSection from "../pages/ClientPage/MobileMenuSection";
import AnouncementsService from "../Api/AnouncementsService";
import socialLinks from '../utils/socialLinks';
import Cookies from 'js-cookie';
const ClientDetaileNavBar = () => {

    const { cookies, logout, data, removeCookie } = useContext(AuthContext);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [announcements, setAnnouncements] = useState([]);

    const location = useLocation(); // Hook to get the current route
    const navigate = useNavigate();

    const anouncementsService = new AnouncementsService();
    const profilePhotoUrl = Cookies.get('profile_photo_url');

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    useEffect(() => {
        // Skip token check for CourseDetailesView route
        if (location.pathname === '/coursedetailesview') {
            return;
        }

        const token = cookies.token;
        if (!token || typeof token !== 'string' || token.trim() === '') {
            console.warn("No valid token found");
            navigate('/StudentLogin');
            return;
        }

        try {
            const decoded = jwtDecode(token);
            if (!decoded || typeof decoded !== 'object') {
                navigate('/StudentLogin');
                return;
            }

            const now = Date.now() / 1000;
            if (!decoded.exp || decoded.exp < now) {
                console.warn("Token expired :", decoded.exp);
                //navigate('/StudentLogin');
            } else {
                console.log("Token valid. Expires at:", new Date(decoded.exp * 1000).toLocaleString());
            }
        } catch (error) {
            console.error("Token validation error:", error.message);
            navigate('/StudentLogin');
        }
    }, [location.pathname]);

    useEffect(() => {
  
        anouncementsService.GetPublicAnouncements( 1, 1)
            .then(res => {
                if (res.data && res.data.status === "success") {
                    setAnnouncements(res.data.data);
                }
            })
            .catch(err => {
                console.error("Failed to fetch announcements", err);
            });
    }, [location.search]);

    return (

        <>

            {/* Start Header Area */}
            <header className="rbt-header rbt-header-10">
                <div className="rbt-sticky-placeholder" />
                {/* Start Header Top  */}
                <div className="rbt-header-top rbt-header-top-1 header-space-betwween bg-not-transparent bg-color-darker top-expended-activation">
                    <div className="container-fluid">
                        <div className="top-expended-wrapper">
                            <div className="top-expended-inner rbt-header-sec align-items-center ">
                                <div className="rbt-header-sec-col rbt-header-left d-none d-xl-block">
                                    <div className="rbt-header-content">
                                        {/* Start Header Information List  */}
                                        <div className="header-info">
                                            <ul className="rbt-information-list">
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-instagram" />
                                                        100k{" "}
                                                        <span className="d-none d-xxl-block">Followers</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-square" />
                                                        500k{" "}
                                                        <span className="d-none d-xxl-block">Followers</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="feather-phone" />
                                                        +91-7808780874
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* End Header Information List  */}
                                    </div>
                                </div>
                                <div className="rbt-header-sec-col rbt-header-center">
                                    <div className="rbt-header-content justify-content-start justify-content-xl-center">
                                        <div className="header-info">
                                            <div className="rbt-header-top-news">
                                                <div className="inner">
                                                    <div className="content">
                                                        <span className="rbt-badge variation-02 bg-color-primary color-white radius-round">
                                                            Hot
                                                        </span>
                                                        {announcements.length > 0 ? (
                                                            <span className="news-text">
                                                                <img
                                                                    src="assets1/images/icons/hand-emojji.svg"
                                                                    alt="Hand Emojji Images"
                                                                />{" "}
                                                                {announcements.map(a => (
                                                                    <span key={a.id}>
                                                                        <strong>{a.title}</strong>: {a.content}{" "}
                                                                    </span>
                                                                ))}
                                                            </span>
                                                        ) : (
                                                            <span className="news-text">No announcements</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="rbt-header-sec-col rbt-header-right mt_md--10 mt_sm--10">
                                    <div className="rbt-header-content justify-content-start justify-content-lg-end">
                                        <div className="header-info d-none d-xl-block">
                                            <ul className="social-share-transparent">
                                                <li>
                                                    <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="rbt-separator d-none d-xl-block" />
                                        <div className="header-info">
                                            <ul className="rbt-dropdown-menu switcher-language">
                                                <li className="has-child-menu">
                                                    <a href="#">
                                                        <img
                                                            className="left-image"
                                                            src="assets1/images/icons/en-us.png"
                                                            alt="Language Images"
                                                        />
                                                        <span className="menu-item">English</span>
                                                        <i className="right-icon feather-chevron-down" />
                                                    </a>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            <a href="#">
                                                                <img
                                                                    className="left-image"
                                                                    src="assets1/images/icons/fr.png"
                                                                    alt="Language Images"
                                                                />
                                                                <span className="menu-item">Français</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <img
                                                                    className="left-image"
                                                                    src="assets1/images/icons/de.png"
                                                                    alt="Language Images"
                                                                />
                                                                <span className="menu-item">Deutsch</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="header-info">
                                            <ul className="rbt-dropdown-menu currency-menu">
                                                <li className="has-child-menu">
                                                    <a href="#">
                                                        <span className="menu-item">INR</span>
                                                        <i className="right-icon feather-chevron-down" />
                                                    </a>
                                                    <ul className="sub-menu hover-reverse">
                                                        <li>
                                                            <a href="#">
                                                                <span className="menu-item">EUR</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <span className="menu-item">GBP</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="header-info">
                                <div className="top-bar-expended d-block d-lg-none">
                                    <button className="topbar-expend-button rbt-round-btn">
                                        <i className="feather-plus" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Header Top  */}
                <div className="rbt-header-wrapper header-space-betwween header-sticky">
                    <div className="container-fluid">
                        <div className="mainbar-row rbt-navigation-center align-items-center">
                            <div className="header-left rbt-header-content">
                                <div className="header-info">
                                    <div className="logo">
                                        <a href="/">
                                            <img
                                                src="assets1/images/logo/logo.png"
                                                alt="Education Logo Images"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="rbt-main-navigation d-none d-xl-block">
                                <nav className="mainmenu-nav">
                                    <ul className="mainmenu">
                                    <li className="has-dropdown has-menu-child-item">
                                            <a href="/">
                                                Home 
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="header-right">
                                {/* Navbar Icons */}
                                <ul className="quick-access">

                                    <li className="account-access rbt-user-wrapper d-none d-xl-block">
                                        <a href="#">
                                            <i className="feather-user" />
                                            {cookies.username}
                                        </a>
                                        <div className="rbt-user-menu-list-wrapper">
                                            <div className="inner">
                                                <div className="rbt-admin-profile">
                                                    <div className="admin-thumbnail">
                                                        <img
                                                            src={profilePhotoUrl}
                                                            alt="User Images"
                                                        />
                                                    </div>
                                                    <div className="admin-info">
                                                        <span className="name">{cookies.username}</span>
                                                        <a
                                                            className="rbt-btn-link color-primary"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                navigate('/StudentDashboard', { state: { section: 'profile' } });
                                                            }}
                                                        >
                                                            View Profile
                                                        </a>
                                                    </div>
                                                </div>
                                                <ul className="user-list-wrapper">
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'dashboard' } });
                                                        }}>
                                                            <i className="feather-home" />
                                                            <span>My Dashboard</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'enrolled' } });
                                                        }}>
                                                            <i className="feather-shopping-bag" />
                                                            <span>Enrolled Courses</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'reviews' } });
                                                        }}>
                                                            <i className="feather-star" />
                                                            <span>Reviews</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'orders' } });
                                                        }}>
                                                            <i className="feather-clock" />
                                                            <span>Order History</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <hr className="mt--10 mb--10" />
                                                <ul className="user-list-wrapper">
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            logout(); // This will clear cookies
                                                            localStorage.clear(); // Clear localStorage
                                                            navigate('/'); // Redirect to home page
                                                        }}>
                                                            <i className="feather-log-out" />
                                                            <span>Logout</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="access-icon rbt-user-wrapper d-block d-xl-none">
                                        <a className="rbt-round-btn" href="#">
                                            <i className="feather-user" />
                                        </a>
                                        <div className="rbt-user-menu-list-wrapper">
                                            <div className="inner">
                                                <div className="rbt-admin-profile">
                                                    <div className="admin-thumbnail">
                                                        <img
                                                            src={profilePhotoUrl}
                                                            alt="User Images"
                                                        />
                                                    </div>
                                                    <div className="admin-info">
                                                        <span className="name">Nipa Bali</span>
                                                        <a
                                                            className="rbt-btn-link color-primary"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                navigate('/StudentDashboard', { state: { section: 'profile' } });
                                                            }}
                                                        >
                                                            View Profile
                                                        </a>
                                                    </div>
                                                </div>
                                                <ul className="user-list-wrapper">
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'dashboard' } });
                                                        }}>
                                                            <i className="feather-home" />
                                                            <span>My Dashboard</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'enrolled' } });
                                                        }}>
                                                            <i className="feather-shopping-bag" />
                                                            <span>Enrolled Courses</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'reviews' } });
                                                        }}>
                                                            <i className="feather-star" />
                                                            <span>Reviews</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate('/StudentDashboard', { state: { section: 'orders' } });
                                                        }}>
                                                            <i className="feather-clock" />
                                                            <span>Order History</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <hr className="mt--10 mb--10" />
                                                <ul className="user-list-wrapper">
                                                 
                                                    <li>
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            logout(); // This will clear cookies
                                                            localStorage.clear(); // Clear localStorage
                                                            navigate('/'); // Redirect to home page
                                                        }}>
                                                            <i className="feather-log-out" />
                                                            <span>Logout</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                             
                                {/* Start Mobile-Menu-Bar */}
                                <div className="mobile-menu-bar d-block d-xl-none">
                                    <div className="hamberger">
                                        <button className="hamberger-button rbt-round-btn">
                                            <i className="feather-menu" />
                                        </button>
                                    </div>
                                </div>
                                {/* Start Mobile-Menu-Bar */}
                            </div>
                        </div>
                    </div>
                    {/* Start Search Dropdown  */}
                    <div className="rbt-search-dropdown">
                        <div className="wrapper">
                            <div className="row">
                                <div className="col-lg-12">
                                    <form action="#">
                                        <input type="text" placeholder="What are you looking for?" />
                                        <div className="submit-btn">
                                            <a className="rbt-btn btn-gradient btn-md" href="#">
                                                Search
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="rbt-separator-mid">
                                <hr className="rbt-separator m-0" />
                            </div>
                            <div className="row g-4 pt--30 pb--60">
                                <div className="col-lg-12">
                                    <div className="section-title">
                                        <h5 className="rbt-title-style-2">Our Top Course</h5>
                                    </div>
                                </div>
                                {/* Start Single Card  */}
                                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div className="rbt-card variation-01 rbt-hover">
                                        <div className="rbt-card-img">
                                            <a href="course-details.html">
                                                <img
                                                    src="assets1/images/course/course-online-01.jpg"
                                                    alt="Card image"
                                                />
                                            </a>
                                        </div>
                                        <div className="rbt-card-body">
                                            <h5 className="rbt-card-title">
                                                <a href="course-details.html">React Js</a>
                                            </h5>
                                            <div className="rbt-review">
                                                <div className="rating">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <span className="rating-count"> (15 Reviews)</span>
                                            </div>
                                            <div className="rbt-card-bottom">
                                                <div className="rbt-price">
                                                    <span className="current-price">$15</span>
                                                    <span className="off-price">$25</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Single Card  */}
                                {/* Start Single Card  */}
                                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div className="rbt-card variation-01 rbt-hover">
                                        <div className="rbt-card-img">
                                            <a href="course-details.html">
                                                <img
                                                    src="assets1/images/course/course-online-02.jpg"
                                                    alt="Card image"
                                                />
                                            </a>
                                        </div>
                                        <div className="rbt-card-body">
                                            <h5 className="rbt-card-title">
                                                <a href="course-details.html">Java Program</a>
                                            </h5>
                                            <div className="rbt-review">
                                                <div className="rating">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <span className="rating-count"> (15 Reviews)</span>
                                            </div>
                                            <div className="rbt-card-bottom">
                                                <div className="rbt-price">
                                                    <span className="current-price">$10</span>
                                                    <span className="off-price">$40</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Single Card  */}
                                {/* Start Single Card  */}
                                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div className="rbt-card variation-01 rbt-hover">
                                        <div className="rbt-card-img">
                                            <a href="course-details.html">
                                                <img
                                                    src="assets1/images/course/course-online-03.jpg"
                                                    alt="Card image"
                                                />
                                            </a>
                                        </div>
                                        <div className="rbt-card-body">
                                            <h5 className="rbt-card-title">
                                                <a href="course-details.html">Web Design</a>
                                            </h5>
                                            <div className="rbt-review">
                                                <div className="rating">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <span className="rating-count"> (15 Reviews)</span>
                                            </div>
                                            <div className="rbt-card-bottom">
                                                <div className="rbt-price">
                                                    <span className="current-price">$10</span>
                                                    <span className="off-price">$20</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Single Card  */}
                                {/* Start Single Card  */}
                                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                    <div className="rbt-card variation-01 rbt-hover">
                                        <div className="rbt-card-img">
                                            <a href="course-details.html">
                                                <img
                                                    src="assets1/images/course/course-online-04.jpg"
                                                    alt="Card image"
                                                />
                                            </a>
                                        </div>
                                        <div className="rbt-card-body">
                                            <h5 className="rbt-card-title">
                                                <a href="course-details.html">Web Design</a>
                                            </h5>
                                            <div className="rbt-review">
                                                <div className="rating">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                                <span className="rating-count"> (15 Reviews)</span>
                                            </div>
                                            <div className="rbt-card-bottom">
                                                <div className="rbt-price">
                                                    <span className="current-price">$20</span>
                                                    <span className="off-price">$40</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Single Card  */}
                            </div>
                        </div>
                    </div>
                    {/* End Search Dropdown  */}
                </div>
                {/* Start Side Vav */}
                <div className="rbt-offcanvas-side-menu rbt-category-sidemenu">
                    <div className="inner-wrapper">
                        <div className="inner-top">
                            <div className="inner-title">
                                <h4 className="title">Course Category</h4>
                            </div>
                            <div className="rbt-btn-close">
                                <button className="rbt-close-offcanvas rbt-round-btn">
                                    <i className="feather-x" />
                                </button>
                            </div>
                        </div>
                        <nav className="side-nav w-100">
                            <ul className="rbt-vertical-nav-list-wrapper vertical-nav-menu">
                                <li className="vertical-nav-item">
                                    <a href="#">Course School</a>
                                    <div className="vartical-nav-content-menu-wrapper">
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Web Design</a>
                                                </li>
                                                <li>
                                                    <a href="#">Art</a>
                                                </li>
                                                <li>
                                                    <a href="#">Figma</a>
                                                </li>
                                                <li>
                                                    <a href="#">Adobe</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Photo</a>
                                                </li>
                                                <li>
                                                    <a href="#">English</a>
                                                </li>
                                                <li>
                                                    <a href="#">Math</a>
                                                </li>
                                                <li>
                                                    <a href="#">Read</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li className="vertical-nav-item">
                                    <a href="#">Online School</a>
                                    <div className="vartical-nav-content-menu-wrapper">
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Photo</a>
                                                </li>
                                                <li>
                                                    <a href="#">English</a>
                                                </li>
                                                <li>
                                                    <a href="#">Math</a>
                                                </li>
                                                <li>
                                                    <a href="#">Read</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Web Design</a>
                                                </li>
                                                <li>
                                                    <a href="#">Art</a>
                                                </li>
                                                <li>
                                                    <a href="#">Figma</a>
                                                </li>
                                                <li>
                                                    <a href="#">Adobe</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li className="vertical-nav-item">
                                    <a href="#">kindergarten</a>
                                    <div className="vartical-nav-content-menu-wrapper">
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Photo</a>
                                                </li>
                                                <li>
                                                    <a href="#">English</a>
                                                </li>
                                                <li>
                                                    <a href="#">Math</a>
                                                </li>
                                                <li>
                                                    <a href="#">Read</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li className="vertical-nav-item">
                                    <a href="#">Classic LMS</a>
                                    <div className="vartical-nav-content-menu-wrapper">
                                        <div className="vartical-nav-content-menu">
                                            <h3 className="rbt-short-title">Course Title</h3>
                                            <ul className="rbt-vertical-nav-list-wrapper">
                                                <li>
                                                    <a href="#">Web Design</a>
                                                </li>
                                                <li>
                                                    <a href="#">Art</a>
                                                </li>
                                                <li>
                                                    <a href="#">Figma</a>
                                                </li>
                                                <li>
                                                    <a href="#">Adobe</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div className="read-more-btn">
                                <div className="rbt-btn-wrapper mt--20">
                                    <a
                                        className="rbt-btn btn-border-gradient radius-round btn-sm hover-transform-none w-100 justify-content-center text-center"
                                        href="#"
                                    >
                                        <span>Learn More</span>
                                    </a>
                                </div>
                            </div>
                        </nav>
                        <div className="rbt-offcanvas-footer"></div>
                    </div>
                </div>
                {/* End Side Vav */}
                <a className="rbt-close_side_menu" href="javascript:void(0);" />
            </header>

            <div className={`popup-mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                <div className="inner-wrapper">
                    <div className="inner-top">
                        <div className="content">
                            <div className="logo">
                                <a href="index.html">
                                    <img src="assets1/images/logo/logo.png" alt="Education Logo Images" />
                                </a>
                            </div>
                            <div className="rbt-btn-close">
                                <button
                                    className="close-button rbt-round-btn"
                                    onClick={toggleMobileMenu}
                                >
                                    <i className="feather-x" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <MobileMenuSection />
                </div>
            </div>
            <Outlet />
        </>

    );
};

export default ClientDetaileNavBar;
